import { Dispatch } from 'react'
import { UserCountry } from "@interfaces/index"
import { ErrorCodes, ErrorActions } from '@constants/index'
import { ErrorAction, setError } from './errorCodeActions'
import { VelvetSDK } from 'sdk'
import { RootState } from 'store'
import { CountryAction } from '@reducers/countryReducer'

export const FETCH_COUNTRY_SUCCESS = 'FETCH_COUNTRY_SUCCESS' as const
export const FETCH_COUNTRY_FAILURE = 'FETCH_COUNTRY_FAILURE' as const
export const FETCH_COUNTRY_REQUEST = 'FETCH_COUNTRY_REQUEST' as const


export const fetchCountrySuccess = (userCountry: UserCountry) => ({
  type: FETCH_COUNTRY_SUCCESS,
  payload: userCountry,
})

export const fetchCountryFailure = (error: string) => ({
  type: FETCH_COUNTRY_FAILURE,
  payload: error,
})

export const fetchCountryRequest = () => ({ type: FETCH_COUNTRY_REQUEST })

export const fetchCountry = () => {
  return async (dispatch: Dispatch<CountryAction | ErrorAction >, getState: () => RootState) => {
    try {
      dispatch(fetchCountryRequest())
      const userCountry = await VelvetSDK.CMS.service().fetchUserCountry();
      const errorFetchAction = getState().errorCode?.fetchAction
      dispatch(fetchCountrySuccess(userCountry))
      errorFetchAction === ErrorActions.USER_COUNTRY && dispatch(setError({ errorCode: '', showErrorModal: false }))
    }
    catch(err){
      console.log("Error occurs while fetching the country:",err)
      const errorUpdate = {
        showErrorModal: false,
        errorCode: ErrorCodes.FETCH_USER_COUNTRY,
        HTTPcode: 404,
        fetchAction: ErrorActions.USER_COUNTRY,
      }
      dispatch(fetchCountryFailure("Fail to fetch userCountry"))
      dispatch(setError(errorUpdate))
      }
    }
  }